import React from 'react';

import { Table } from 'react-bootstrap';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import { generateKeyStr } from '../../../infrastructure/utils/common';

import { arrayMove } from './ArrayMove';

const SortableItem = SortableElement(({ value, Element, ...props }) => (
  <Element value={value} {...props} />
));

const SortableTable = SortableContainer(
  ({ content, headers, notHeader, ...props }) => (
    <Table hover>
      {!notHeader && (
        <thead>
          <tr>
            <th style={{ width: '2%' }} />
            {headers.map(header => (
              <th
                key={`header-${generateKeyStr()}`}
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {content.map((value, index) => (
          <SortableItem
            key={`item-${generateKeyStr()}`}
            index={index}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            value={value}
            notHeader
            ind={index}
            {...props}
          />
        ))}
      </tbody>
    </Table>
  )
);

class State {
  key = generateKeyStr();
}

export default class DragnDropTable extends React.Component {
  state = new State();
  onSortEnd = ({ oldIndex, newIndex }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onChange, content, receiver, customReorder } = this.props;
    if (!onChange) return;
    if (!customReorder) {
      const newArray = arrayMove(content, oldIndex, newIndex);
      onChange({
        [receiver]: newArray,
      });
      return;
    }
    onChange(oldIndex, newIndex);
  };

  render() {
    const { ...props } = this.props;
    const { key } = this.state;
    return (
      <SortableTable
        onSortEnd={this.onSortEnd}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        pr={key}
        distance={3}
        {...props}
      />
    );
  }
}
